module.exports = __webpack_public_path__ + "assets/img/thumb-Kitome-Testimonials-Video.cd0b2b5a.jpg";